/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Catalog} from './Catalog';
import {Unit} from './Unit';
import {Picture} from './Picture';
import {Supplier} from './Supplier';
import {Manufacturer} from './Manufacturer';
import {ManufacturerSeries} from './ManufacturerSeries';
import {ProductTag} from './ProductTag';
import {ProductStatus} from './ProductStatus';
import {ProductGroup} from './ProductGroup';
import {FeatureUnionCondition} from './FeatureUnionCondition';
import {FeatureValue} from './FeatureValue';
import {YouTube} from './YouTube';
import {ProductPrice} from './ProductPrice';
import {ProductRemain} from './ProductRemain';
import {ProductCodeValue} from './ProductCodeValue';
import {SystemTag} from './SystemTag';
import {Brand} from './Brand';
import {Tax} from './Tax';
import {IdAndHeader} from './IdAndHeader'

export interface ProductRelated {
  units: IdAndHeader[];
  featureUnionConditions: IdAndHeader[];
  productStatuses: IdAndHeader[];
  productGroups: IdAndHeader[];
  productTags: IdAndHeader[];
  countries: IdAndHeader[];
  taxs: IdAndHeader[];
  suppliers: IdAndHeader[];
}

export interface Product {
  id: number;
  header: string;
  fullHeader: string;
  manufacturerSiteLink?: number;
  multiplicitySupplier?: number;
  multiplicityOrder?: number;
  minOrderQuantity?: number;
  barCode?: string;
  articul?: string;
  syncUid?: string;
  content?: string;
  description?: string;
  price: number;
  enabled: boolean;
  pos: number;
  parentId?: number;
  productStatusId?: number;
  productGroupId?: number;
  supplierId?: number;
  manufacturerId?: number;
  brandId?: number;
  manufacturerSeriesId?: number;
  featureUnionConditionId?: number;
  catalogId?: number;
  countryId?: number;
  width?: number;
  height?: number;
  length?: number;
  weight?: number;
  volume?: number;
  unitId?: number;
  pictureId: number;
  parent?: Product;
  catalog: Catalog;
  unit?: Unit;
  picture: Picture;
  pictures: Picture[];
  suppliers?: Supplier[];
  featureValues?: FeatureValue[];
  manufacturer?: Manufacturer;
  brand?: Brand;
  manufacturerSeries?: ManufacturerSeries;
  featureUnionCondition?: FeatureUnionCondition;
  productStatus: ProductStatus;
  productGroup?: ProductGroup;
  catalogs?: Catalog[];
  productTags?: ProductTag[];
  productSystemTags?: SystemTag[] | number[];
  updatedAt?: Date;
  createdAt?: Date | string;
  deleted?: boolean;
  linkedGoods?: Product[];
  analogs?: Product[];
  relatedGoods?: Product[];
  videos?: YouTube[];
  prices?: ProductPrice[];
  remains?: ProductRemain[];
  codes?: ProductCodeValue[];
  tax?: Tax;
  taxId?: number;

  isCopy?: boolean;
}
